var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          ref: "menu",
          staticClass: "vks-ge-tissue-dot-menu",
          style: _vm.menuStyle,
          attrs: { role: "menu" },
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("p", { staticClass: "vks-ge-tissue-dot-menu-title" }, [
            _vm._v(_vm._s(_vm.tissue)),
          ]),
          _c("p", { staticClass: "vks-ge-tissue-dot-menu-subtitle" }, [
            _vm._v(_vm._s(_vm.annotation)),
          ]),
          _c(
            "button",
            {
              staticClass: "vks-ge-tissue-dot-menu-btn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle-select")
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.isSelected ? "Deselect tissue" : "Select tissue") +
                  " "
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }